/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React from 'react';
import { FieldWrapper } from '@td-client-frontend/common';
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import { ControlsCycle } from '@td-client-frontend/icons';
import clsx from 'clsx';
import { useDdf } from '../../context/ddf-context';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';

export function Handler(props) {
  const { change } = useFormApi();
  const { text, handler } = useFieldApi(props);
  const { handlers } = useDdf();

  const handleClick = () => {
    handlers[handler](change);
  };

  return (
    <FieldWrapper>
      <button onClick={handleClick} className={clsx('space-x-2 btn text-left p-0')}>
        <ControlsCycle />
        <span className="text-primary-500">{text}</span>
      </button>
    </FieldWrapper>
  );
}
